<div
	id="all"
	cdkDropList
	[cdkDropListData]="allButtons"
	class="buttons-list"
	(cdkDropListDropped)="drop($event)"
	[cdkDropListEnterPredicate]="noReturnPredicate"
>
	<div class="box-buttons-options" *ngFor="let button of allButtons; let i = index" [cdkDragData]="button" cdkDrag>
		<div class="custom-placeholder" *cdkDragPlaceholder></div>
		<i class="{{ button.icon }} icon-left"></i>
		<div class="w-100 drag-drop-link-form">
			<ng-container *ngIf="isPhoneButton(button); else defaultLinkInput">
				<div class="phone-link-fields">
					<mat-form-field class="phone-country-field">
						<mat-select
							[placeholder]="'phoneCountry' | translate"
							[value]="button.phoneCountryCode"
							(selectionChange)="onPhoneCountryChange(button, $event.value)"
							(blur)="blurEvent.emit()"
						>
							<mat-option [value]="''">{{ 'clearPhoneCountry' | translate }}</mat-option>
							<mat-option *ngFor="let option of phoneCountryOptions" [value]="option.value">
								{{ option.label }}
							</mat-option>
						</mat-select>
						<mat-error *ngIf="showPhoneCountryError(button)">
							{{ 'requiredField' | translate }}
						</mat-error>
					</mat-form-field>
					<mat-form-field class="phone-number-field">
						<input
							matInput
							type="tel"
							[placeholder]="button.label | translate"
							(input)="onLinkInputChange(button, $event.target.value)"
							(blur)="blurEvent.emit()"
							[value]="button.tempUrl"
						/>
						<mat-error *ngIf="showPhoneNumberError(button)">
							{{ 'requiredField' | translate }}
						</mat-error>
					</mat-form-field>
				</div>
			</ng-container>
			<ng-template #defaultLinkInput>
				<mat-form-field>
					<input
						matInput
						[placeholder]="button.label | translate"
						(input)="onLinkInputChange(button, $event.target.value)"
						(blur)="blurEvent.emit()"
						[value]="button.tempUrl"
					/>
				</mat-form-field>
			</ng-template>
		</div>
		<i class="fas fa-grip-vertical icon-right"></i>
	</div>
</div>
